import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

function PageTitle({ pageTitle, pageDesc }) {
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
    </Helmet>
  )
}

PageTitle.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  pageDesc: PropTypes.string
};

export default PageTitle;
